import React, { useEffect } from "react";

import HeroSlider from "../components/HeroSlider";
import MovieArea from "../components/MovieArea";
import EventOffer from "../components/EventOffer";
import { useNavigate, useSearchParams } from "react-router-dom";

const HomePage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get("b");

    if (code) {
      // redirect to your existing route
      navigate(`/b/${code}`, { replace: true });
    }
  }, []);
  return (
    <>
      {/* Hero Slider */}
      <HeroSlider />

      {/* Banner Section */}

      <picture className="homepage-banner">
        <source
          media="(max-width: 480px)"
          srcSet="/assets/img/homepage-banner-mobile.png"
        />
        <source
          media="(max-width: 768px)"
          srcSet="/assets/img/homepage-banner-tablet.png"
        />
        <img
          src="/assets/img/homepage-banner-desktop.png"
          alt="Homepage Banner"
        />
      </picture>

      {/* Movie Area */}
      <MovieArea />

      {/* Offers Section */}
      <EventOffer />

      {/* Instagram Feed */}
      <div className="container">
        <div
          className="elfsight-app-9807590a-7791-4efc-b004-385361d3451b"
          data-elfsight-app-lazy
        ></div>
      </div>
    </>
  );
};

export default HomePage;
